export default {
    API_ATENDENTE: 'https://api.sistefood.com.br:5000/site/',
    API_ATENDENTE_MESA_ATENDENTE: 'https://api.sistefood.com.br:5000/app/',
    API_PRODUTO: 'https://api.sistefood.com.br:5000/site/',
    API_ACOMPANHAMENTO: 'https://api.sistefood.com.br:5000/sistefood/',
    API_PARAMETRO:'https://api.sistefood.com.br:5000/sistefood/',
    API_USUARIO:'https://api.sistefood.com.br:5000/site/',
    API_QRCODE:'https://api.sistefood.com.br:5000/site/',
    API_MESA:'https://api.sistefood.com.br:5000/app/',
    API_PRODUTO_LOTE: 'https://api.sistefood.com.br:5000/app/',
    API_PAGAMENTO: 'https://api.sistefood.com.br:5000/app/',
    API_PAGAMENTO_DELIVERY: 'https://api.sistefood.com.br:5000/sistefood/',
    API_DASHBOARD: 'https://api.sistefood.com.br:5000/sistefood/',
    API_COUVERT:'https://api.sistefood.com.br:5000/app/',
    API_TAXES:'https://api.sistefood.com.br:5000/app/',
    API_DELIVERY:'https://api.sistefood.com.br:5000/sistefood/',
    API_PERSON:'https://api.sistefood.com.br:5000/sistefood/',
    API_DELIVERY_MAN:'https://api.sistefood.com.br:5000/sistefood/',
    API_TABLE_COUNT:'https://api.sistefood.com.br:5000/app/',
    API_DELIVERY_COUNT:'https://api.sistefood.com.br:5000/sistefood/',
    API_COZINHA:'https://api.sistefood.com.br:5000/sistefood/',
    API_PRINT:'https://api.sistefood.com.br:5000/sistefood/',
    API_FREIGHT:'https://api.sistefood.com.br:5000/sistefood/',
    API_PRODUCT_COMPLEMENT:'https://api.sistefood.com.br:5000/cardapio/',
    API_CONSULT_SALE:'https://api.sistefood.com.br:5000/sistefood/',
    API_FORM_OF_PAYMENT:'https://api.sistefood.com.br:5000/sistefood/',
    API_EXPENSE:'https://api.sistefood.com.br:5000/sistefood/',
    API_REVENUE:'https://api.sistefood.com.br:5000/sistefood/',
    API_CURRENT_ACCOUNT:'https://api.sistefood.com.br:5000/sistefood/',
    API_BILLS_TO_PAY:'https://api.sistefood.com.br:5000/sistefood/',
    API_BILLS_TO_RECEIVE:'https://api.sistefood.com.br:5000/sistefood/',
    API_NOTE_ENTRY:'https://api.sistefood.com.br:5000/sistefood/',
    API_NOTE_SINGLE:'https://api.sistefood.com.br:5000/site/',
    API_INVENTORY:'https://api.sistefood.com.br:5000/site/',
    API_MANUFACTOR:'https://api.sistefood.com.br:5000/sistefood/',
    API_CFOP:'https://api.sistefood.com.br:5000/sistefood/',
    API_SECTION:'https://api.sistefood.com.br:5000/sistefood/',
    API_CATEGORY:'https://api.sistefood.com.br:5000/sistefood/',
    API_EMAIL:'https://api.sistefood.com.br:5000/sistefood/',
    API_NCM:'https://api.sistefood.com.br:5000/sistefood/',
    API_CONSULT_CNPJ:'https://api.sistefood.com.br:5000/sistefood/',
    API_TELE_SALES:'https://api.sistefood.com.br:5000/sistefood/',
    API_PARAMETER_SISTEFOOD_GENERAL:'https://api.sistefood.com.br:5000/sistefood/',
    API_LOANDING_DFE:'https://api.sistefood.com.br:5000/sistefood/',
    API_SELLER:'https://api.sistefood.com.br:5000/sistefood/',
    API_LABEL:'https://api.sistefood.com.br:5000/sistefood/',
    API_SANGRIA:'https://api.sistefood.com.br:5000/sistefood/',
    API_WORTHEXCHANGE:'https://api.sistefood.com.br:5000/sistefood/',
    API_SUPPLY:'https://api.sistefood.com.br:5000/sistefood/',
    VIACEP: 'https://viacep.com.br/ws/',

    // API_ATENDENTE: 'http://192.168.1.43:9001/site/',
    // API_ATENDENTE_MESA_ATENDENTE: 'http://192.168.1.43:9001/app/',
    // API_PRODUTO: 'http://192.168.1.43:9001/site/',
    // API_ACOMPANHAMENTO: 'http://192.168.1.43:9001/sistefood/',
    // API_PARAMETRO:'http://192.168.1.43:9001/sistefood/',
    // API_USUARIO:'http://192.168.1.43:9001/site/',
    // API_QRCODE:'http://192.168.1.43:9001/site/',
    // API_MESA:'http://192.168.1.43:9001/app/',
    // API_PRODUTO_LOTE: 'http://192.168.1.43:9001/app/',
    // API_PAGAMENTO: 'http://192.168.1.43:9001/app/',
    // API_PAGAMENTO_DELIVERY: 'http://192.168.1.43:9001/sistefood/',
    // API_DASHBOARD: 'http://192.168.1.43:9001/sistefood/',
    // API_COUVERT:'http://192.168.1.43:9001/app/',
    // API_TAXES:'http://192.168.1.43:9001/app/',
    // API_DELIVERY:'http://192.168.1.43:9001/sistefood/',
    // API_PERSON:'http://192.168.1.43:9001/sistefood/',
    // API_DELIVERY_MAN:'http://192.168.1.43:9001/sistefood/',
    // API_TABLE_COUNT:'http://192.168.1.43:9001/app/',
    // API_DELIVERY_COUNT:'http://192.168.1.43:9001/sistefood/',
    // API_COZINHA:'http://192.168.1.43:9001/sistefood/',
    // API_PRINT:'http://192.168.1.43:9001/sistefood/',
    // API_FREIGHT:'http://192.168.1.43:9001/sistefood/',
    // API_PRODUCT_COMPLEMENT:'http://192.168.1.43:9001/cardapio/',
    // API_CONSULT_SALE:'http://192.168.1.43:9001/sistefood/',
    // API_FORM_OF_PAYMENT:'http://192.168.1.43:9001/sistefood/',
    // API_EXPENSE:'http://192.168.1.43:9001/sistefood/',
    // API_REVENUE:'http://192.168.1.43:9001/sistefood/',
    // API_CURRENT_ACCOUNT:'http://192.168.1.43:9001/sistefood/',
    // API_BILLS_TO_PAY:'http://192.168.1.43:9001/sistefood/',
    // API_BILLS_TO_RECEIVE:'http://192.168.1.43:9001/sistefood/',
    // API_NOTE_ENTRY:'http://192.168.1.43:9001/sistefood/',
    // API_NOTE_SINGLE:'http://192.168.1.43:9001/site/',
    // API_INVENTORY:'http://192.168.1.43:9001/site/',
    // API_MANUFACTOR:'http://192.168.1.43:9001/sistefood/',
    // API_CFOP:'http://192.168.1.43:9001/sistefood/',
    // API_SECTION:'http://192.168.1.43:9001/sistefood/',
    // API_CATEGORY:'http://192.168.1.43:9001/sistefood/',
    // API_EMAIL:'http://192.168.1.43:9001/sistefood/',
    // API_NCM:'http://192.168.1.43:9001/sistefood/',
    // API_CONSULT_CNPJ:'http://192.168.1.43:9001/sistefood/',
    // API_TELE_SALES:'http://192.168.1.43:9001/sistefood/',
    // API_PARAMETER_SISTEFOOD_GENERAL:'http://192.168.1.43:9001/sistefood/',
    // API_LOANDING_DFE:'http://192.168.1.43:9001/sistefood/',
    // API_SELLER:'http://192.168.1.43:9001/sistefood/',
    // API_LABEL:'http://192.168.1.43:9001/sistefood/',
    // API_SANGRIA:'http://192.168.1.43:9001/sistefood/',
    // API_WORTHEXCHANGE:'https://192.168.1.43:9001/sistefood/',
    // API_SUPPLY:'http://192.168.1.43:9001/sistefood/',
    // VIACEP: 'https://viacep.com.br/ws/',
};